module.exports = __webpack_public_path__ + "static/img/NYCrooftop_Jun_2017_carousel_v2.6ad4f9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NYCrooftop_Jun_2017_carousel_v2.jpg
// module id = 317
// module chunks = 2